<base-site-layout
    [heading]="'Bestellposition verknüpfen' | translate"
    headerIcon="fas fa-link"
    [isDialog]="true"
    (dialogCloseClicked)="cancel()"
>
    <div class="dialog-content">
        <div class="input-group mb-2">
            <span class="input-group-text"><em class="fas fa-search"></em></span>
            <input
                id="order-search"
                type="text"
                class="form-control"
                [formControl]="searchControl"
                [attr.aria-label]="'Bestellung suchen' | translate"
                [placeholder]="'Bestellnummer, ERP-Nummer oder Lieferant' | translate"
            />
        </div>

        <div class="mb-2 d-flex flex-column">
            <label>{{ 'Bestelldatum' | translate }}</label>
            <iim-date-range-picker
                [date]="orderDateRange"
                [fromLabel]="'Von' | translate"
                [toLabel]="'Bis' | translate"
                [placeholderFrom]="'Bestelldatum von' | translate"
                [placeholderTo]="'Bestelldatum bis' | translate"
                (dateChange)="applyFilter()"
            ></iim-date-range-picker>
        </div>

        <div class="mb-2">
            <mat-checkbox [formControl]="includeClosedControl">
                {{ 'zeige geschlossene' | translate }}
            </mat-checkbox>
        </div>

        <div class="text-muted mb-2">
            {{
                'Angezeigt werden offene Bestellungen des Lieferanten im Buchungskreis der Rechnung (Status „Bestellt“, „Auftragsbestätigung“ oder „Teillieferung“). Mit „zeige geschlossene“ kommen gelieferte, abgeschlossene und abgerechnete Bestellungen dazu. Die Suche durchsucht die angezeigten Bestellungen.'
                    | translate
            }}
        </div>

        @if (store.searching()) {
            <div class="py-2 text-center">
                <i class="fas fa-spinner fa-spin"></i>
            </div>
        } @else if (store.candidates().length === 0) {
            <div class="alert alert-info mb-2">
                {{ 'Keine passende Bestellung gefunden.' | translate }}
            </div>
        }

        <ul class="list-group">
            @for (order of store.candidates(); track order.orderId) {
                <li
                    class="list-group-item list-group-item-action hoverable cursor-pointer"
                    [class.already-linked]="isCurrentOrder(order.orderId)"
                    (click)="store.toggleOrder(order.orderId)"
                >
                    <div class="row align-items-center">
                        <div class="col-auto">
                            <em class="fas" [ngClass]="store.expandedOrderId() === order.orderId ? 'fa-chevron-down' : 'fa-chevron-right'"></em>
                        </div>
                        <div class="col">
                            <!-- ERP number first when there is one: it is what the invoice shows once saved. -->
                            <div class="fw-bold">{{ order.erpOrderNumber || order.orderId }}</div>
                            <div class="text-muted">
                                @if (order.erpOrderNumber) {
                                    {{ 'eProc-Nr.' | translate }} {{ order.orderId }}
                                }
                                @if (order.supplierName) {
                                    @if (order.erpOrderNumber) {
                                        ·
                                    }
                                    {{ order.supplierName }}
                                }
                            </div>
                        </div>
                        <div class="col-auto text-muted">
                            @if (order.orderDate) {
                                {{ order.orderDate | dayjs: 'L' }}
                            }
                        </div>
                    </div>
                </li>

                @if (store.expandedOrderId() === order.orderId) {
                    @for (item of order.items; track item.orderItemId) {
                        <li
                            class="list-group-item list-group-item-action hoverable cursor-pointer ps-5"
                            [class.already-linked]="isCurrentRelation(order.orderId, item)"
                            (click)="store.selectItem(order.orderId, item)"
                        >
                            <div class="row align-items-center">
                                <div class="col-auto">
                                    <mat-radio-button
                                        color="primary"
                                        name="orderItem"
                                        [checked]="store.selectedItem()?.orderItemId === item.orderItemId"
                                    ></mat-radio-button>
                                </div>
                                <div class="col">
                                    <div class="fw-bold">
                                        {{ item.position }} · {{ item.name }}
                                        @if (isCurrentRelation(order.orderId, item)) {
                                            <span class="badge bg-primary ms-2">{{ 'aktuell verknüpft' | translate }}</span>
                                        }
                                    </div>
                                    <div class="small text-muted">
                                        @if (item.articleNumber) {
                                            {{ 'Artikelnummer' | translate }}: {{ item.articleNumber }}
                                        }
                                        @if (openQuantity(item) !== null) {
                                            | {{ 'offen' | translate }}: {{ openQuantity(item) }}
                                        }
                                    </div>
                                </div>
                            </div>
                        </li>
                    } @empty {
                        <li class="list-group-item ps-5 text-muted">{{ 'Diese Bestellung hat keine Positionen.' | translate }}</li>
                    }
                }
            }
        </ul>
    </div>

    <div class="dialog-footer d-flex justify-content-between gap-2 mt-3">
        <div>
            @if (isLinked()) {
                <button type="button" class="btn btn-outline-danger" (click)="removeLink()">
                    {{ 'Verknüpfung entfernen' | translate }}
                </button>
            }
        </div>
        <div class="d-flex gap-2">
            <button type="button" class="btn btn-secondary" (click)="cancel()">{{ 'Abbrechen' | translate }}</button>
            <button type="button" class="btn btn-primary" [disabled]="!hasSelection()" (click)="confirm()">
                {{ 'Verknüpfen' | translate }}
            </button>
        </div>
    </div>
</base-site-layout>
